import React, { useState, useRef } from "react";

import { Link, withRouter } from "react-router-dom";

import Layout from "../../components/Layout";

import { apiCRMv3 } from "../../services/api";

import Swal from "sweetalert2";

const ImportClientList = (props) => {
    const [loaded, setLoaded] = useState(true);

    const branchCode = useRef(null);


    async function getBranchCode() {
        try {
            setLoaded(false);
            const responseImportPerBranch = await apiCRMv3.post(
                `clients-list/load-from-api`,
                {
                    branches: [branchCode.current.value],
                }
            );

            console.log(branchCode.current.value)
            if (
                responseImportPerBranch.data.error ||
                responseImportPerBranch.status === 500
            ) {
                Swal.fire(
                    "Erro!",
                    "Problemas ao Importar Funil. Por favor contate o suporte!",
                    "error"
                );

                setLoaded(true);
            } else {
                Swal.fire(
                    "Importando!",
                    "O Funil Está Sendo Importada e Logo Estará Disponível!",
                    "success"
                );

                setLoaded(true);
            }
        } catch (err) {
            console.log(err);
            Swal.fire(
                "Erro!",
                "Problemas ao Importar o Funil. Por favor contate o suporte!",
                "error"
            );

            setLoaded(true);
        }
    }

    return (
        <Layout
            menuActive=""
            pageTitle="Importar Funis Produtos Associados 
            Por Filial"
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <small>
                                    <Link
                                        className="label label-default"
                                        to="/dashboard"
                                    >
                                        Dashboard
                                    </Link>
                                </small>{" "}
                                <span className="label label-success">
                                    Importar Funis Produtos Associados Por Filial
                                </span>
                            </div>
                        </div>
                        <div
                            className={`card-body table-responsive ${loaded ? "" : "__loading"
                                }`}
                        >
                            <div className="row">
                                <form className="col-xs-12">
                                    <div className="row">
                                        {/* Coluna do formulário */}
                                        <div className="col-xs-12 col-md-4">
                                            <label htmlFor="branchCode-filter">
                                                Codigo Filial
                                            </label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                id="branchCode-filter"
                                                ref={branchCode}
                                            />
                                            <button
                                                className="btn btn-primary btn-large btn-block"
                                                type="button"
                                                onClick={(e) => {
                                                    getBranchCode();
                                                }}
                                                style={{ marginTop: 10 }}
                                            >
                                                Importar!
                                            </button>
                                        </div>

                                        {/* Coluna dos avisos */}
                                        <div className="col-xs-12 col-md-8">
                                            <p>Após o início da importação, esperar alguns minutos e verificar no aplicativo. Caso não apareça a lista, contate o suporte!</p>
                                            <p>Por favor, não importar para a mesma filial mais de uma vez sem antes contatar o suporte!</p>
                                            <p>Nomeclatura das filiais pra garantirmos o bom funcionamento.</p>
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4">Filiais Padrão <b>10002</b></div>
                                                <div className="col-xs-12 col-sm-4">Filiais GO <b>140008</b></div>
                                                <div className="col-xs-12 col-sm-4">Filiais Radisco <b>240002</b></div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <br />

                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(ImportClientList);
